module.exports = __webpack_public_path__ + "img/LargeCorner.4ac3027a.png";